module.exports = __webpack_public_path__ + "img/89.8548ad9.png";